module.exports = require("../../filter-list/FilterList.vue");